"use strict";
exports.__esModule = true;
var OatmealCookie = require('oatmeal-cookie');
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.get = function (key) {
        try {
            return OatmealCookie.get(key);
        }
        catch (error) {
            return null;
        }
    };
    Cookie.set = function (key, value, schemaParams) {
        var _a = schemaParams.expires, expires = _a === void 0 ? Infinity : _a, domain = schemaParams.domain, _b = schemaParams.path, path = _b === void 0 ? '/' : _b;
        OatmealCookie.set(key, value, { expires: expires, domain: domain, path: path });
    };
    Cookie.remove = function (key) {
        OatmealCookie.expire(key, {
            path: '/'
        });
    };
    return Cookie;
}());
exports["default"] = Cookie;
